import Endpoint from "@/utils/endPoint";

const teacherMineEndpoint = new Endpoint("/teachers/mine");
const teacherEndpoint = new Endpoint("/teachers/teacherId");
const klassTeacherListEndpoint = new Endpoint("/teachers/");
const schoolTeacherListEndpoint = new Endpoint("/teachers/teachers/");
const teacherIntroEndpoint = new Endpoint("/teachers/{teacherId}/introduction");


const teacherInfoMineEndpoint = new Endpoint("/teachers/info/mine");
const klassTeacherInfoListEndpoint = new Endpoint("/teachers/info");
const schoolTeacherInfoEndpoint = new Endpoint("/teachers/teachers/info");
const teacherInfoEndpoint = new Endpoint("/teachers/info/{teacher_info_id}");
const schoolTeacherInfoWithIdEndpoint = new Endpoint("/teachers/teachers/info/{teacher_info_id}");
const teacherMobileEndpoint = new Endpoint("/teachers/teachers/info/{teacherId}/sensitive");
const deactivateTeacherInfoEndpoint = new Endpoint("/teachers/teachers/info/{teacherInfoId}/deactivate");


const teacherRoleListEndpoint = new Endpoint("/teachers/roles/teachers/");
const deactivateTeacherEndpoint = new Endpoint("/teachers/teachers/{teacherId}/deactivate");

class TeacherService {
    async getTeacherMineListService(params) {
        const result = await teacherMineEndpoint.get(params);
        return result;
    }

    async getTeacherListService(params) {
        const { isManager = true, ...param } = params;
        let result = null;
        if (isManager) {
            result = await schoolTeacherListEndpoint.get(param);
        } else {
            result = await klassTeacherListEndpoint.get(param);
        }
        return result;
    }

    async getTeacherService(params) {
        const result = await teacherEndpoint.get(params);
        return result;
    }

    async getTeacherIntroService(params) {
        const result = await teacherIntroEndpoint.get(params);
        return result;
    }

    async updateTeacherIntroService(params) {
        const result = await teacherIntroEndpoint.put(params);
        return result;
    }
}

class TeacherInfoService {
    // 老师模块
    
    async createTeacherInfoService(params) {
        const result = await schoolTeacherInfoEndpoint.post(params);
        return result;
    }
    
    async getTeacherInfoMineListService(params) {
        const result = await teacherInfoMineEndpoint.get(params);
        return result;
    }

    async getTeacherInfoListService(params) {
        const { isManager = true, ...param } = params;
        let result = null;
        if (isManager) {
            result = await schoolTeacherInfoEndpoint.get(param);
        } else {
            result = await klassTeacherInfoListEndpoint.get(param);
        }
        return result;
    }

    async getTeacherInfoService(params) {
        const result = await teacherInfoEndpoint.get(params);
        return result;
    }

    async updateTeacherInfoService(params) {
        const { teacher_info_id, ...param } = params;
        const result = await schoolTeacherInfoWithIdEndpoint.put(param, { teacher_info_id });
        return result;
    }

    async getTeacherIntroService(params) {
        const result = await teacherIntroEndpoint.get(params);
        return result;
    }

    async updateTeacherIntroService(params) {
        const result = await teacherIntroEndpoint.put(params);
        return result;
    }

    async getTeacherRoleListService(params) {
        const result = await teacherRoleListEndpoint.get(params);
        return result;
    }

    async updateTeacherMobileService(params) {
        const { teacherId, ...param } = params;
        const result = await teacherMobileEndpoint.put(param, { teacherId });
        return result;
    }

    async deactivateTeacherInfoService(params) {
        const { teacherInfoId, ...param } = params;
        const result = await deactivateTeacherInfoEndpoint.put(param, { teacherInfoId });
        return result;
    }

    // 老师-----班级关系模块
    
    async createKlassTeacherService(params) {
        const result = await schoolTeacherListEndpoint.post(params);
        return result;
    }

    async deactivateKlassTeacherService(params) {
        const { teacherId, ...param } = params;
        const result = await deactivateTeacherEndpoint.put(param, { teacherId });
        return result;
    }
}

export const teacherService = new TeacherService();

export default new TeacherInfoService();
